
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`La petite histoire`}</em></p>
    <p>{`La technique du vaccin à vecteur a déjà été
`}<a parentName="p" {...{
        "href": "18531943"
      }}>{`utilisée avec succès par Johnson&Johnson pour lutter contre Ebola`}</a>{`.
Jusqu’à présent, c’était le seul vaccin qui utilisait cette technologie.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;